module.exports = __webpack_public_path__ + "static/Q7Answer_Stick_wishmastree-e034ad4ac59d6f507d8e1cae4e2e5d1d.jpg";